import { createFileRoute } from '@tanstack/react-router';

import { getReviewOptions } from '@/module/Author/Review';

export const Route = createFileRoute('/_auth/author/_author/review/_review/$reviewId/_layout')({
  loader: async ({ params: { reviewId }, context: { queryClient } }) => {
    const review = await queryClient.ensureQueryData(getReviewOptions(reviewId));

    return {
      review,
      crumb: review.title,
    };
  },
});
